import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=82410a64"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports